// @flow
import { Container, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { graphql } from 'gatsby';
import * as React from 'react';

import { Layout } from '../../components/layout';
import Markdown from '../../components/styled/markdown';
import Seo from '../../components/seo';

type Props = {
  data: { contentfulPolitica: any },
};

const useStyles = makeStyles((theme) => ({
  container: {
    margin: theme.spacing(15, 0),
  },
}));

const Policy = ({ data: { contentfulPolitica } }: Props) => {
  const classes = useStyles();

  return (
    <Layout>
      <Seo
        title={contentfulPolitica.nombre}
        description={contentfulPolitica.content.content.slice(160)}
      />

      <Container>
        <Grid
          className={classes.container}
          spacing={3}
          container
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={10} lg={8}>
            <Typography variant="h3">{contentfulPolitica.nombre}</Typography>
          </Grid>
          <Grid item xs={12} md={10} lg={8}>
            <Markdown>{contentfulPolitica.content.content}</Markdown>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export const query = graphql`
  query PolicyPage($slug: String!) {
    contentfulPolitica(slug: { eq: $slug }) {
      nombre
      content {
        content
      }
    }
  }
`;

export default Policy;
